/**
 * `bankRecon.*` — read-only ledger view per account (V1.0). Statement
 * upload + matching land in V1.x.
 */
import { z } from "zod";
import { isoDate, uuid } from "../_common.js";

export const listAccountLedgerInput = z.object({
  bankAccountId: uuid,
  dateFrom: isoDate.optional(),
  dateTo: isoDate.optional(),
});

const ledgerRow = z.object({
  id: z.string(),
  source: z.enum(["receipt", "vendor_payment", "cash_movement"]),
  valueDate: isoDate,
  /** Signed paise — positive = money in, negative = money out. */
  signedPaise: z.string().regex(/^-?\d+$/),
  label: z.string(),
  reference: z.string().nullable(),
  linkedEntityType: z.string().nullable(),
  linkedEntityId: z.string().nullable(),
});

export const listAccountLedgerOutput = z.object({
  rows: z.array(ledgerRow),
  netMovementPaise: z.string().regex(/^-?\d+$/),
  // Signed: a credit_card account (or an overdrawn cash drawer) closes
  // negative — that's the liability. Unsigned `moneyPaise` 500s on it.
  closingBalancePaise: z.string().regex(/^-?\d+$/),
});

export type ListAccountLedgerInput = z.infer<typeof listAccountLedgerInput>;
export type ListAccountLedgerOutput = z.infer<typeof listAccountLedgerOutput>;
export type LedgerRow = z.infer<typeof ledgerRow>;
